export const ADD_ITEM = "ADD_ITEM";
export const PRIVACY_SWITCH = "PRIVACY_SWITCH"
export const TERM_SWITCH = "TERM_SWITCH"
export const COOKIE_SWITCH = "COOKIE_SWITCH"